const SELECTORS = {
  cookies: '.js-cookies',
  accept: '.js-accept-cookies',
};

class Cookies {
  constructor() {
    this.btn = document.querySelector(SELECTORS.accept);
    this.cookies = document.querySelector(SELECTORS.cookies);
    this.init();
  }

  init() {
    if (this.btn && this.cookies) {
      const currCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith('britishwax_cookie='));
      if (!currCookie) {
        this.cookies.classList.remove('hidden');
      }
      this.btn.addEventListener('click', (event) => {
        event.preventDefault();
        let date = new Date(Date.now() + 2592000e3); // set cookie for 30 days
        date = date.toUTCString();
        document.cookie = `britishwax_cookie=1; path=/; expires=${date}`;
        this.cookies.remove();
      });
    }
  }
}

export default () => {
  return new Cookies();
};
